/* eslint-disable no-console */
import React, {useEffect, useState} from 'react'
import {PageLink, PageTitle} from 'layout/master-layout'
// import {toast} from 'react-toastify'
// import {ILogin} from 'models/Auth'
// import {ITab} from 'helpers/ui-components/KTTab'
import Spinner from 'layout/common/Spinner'
import {useAuth} from 'context/AuthProvider'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router-dom'
import {
 IActivationConfig,
 IApproveReject,
 IUserAction,
} from 'models/UserManagement'
import {fetchUserDetails} from 'utils/api/auth/userService'
import {IUserDetails} from 'models/Auth'
import {IFormData, IFormField} from 'models/Common'
import {
 activateUser,
 bulkApproveRejectUsers,
 deActivateUser,
 sendVerificationLink,
 userActivationConfig,
} from 'utils/api/auth/userManagementService'
import {MyAccountPage} from 'module/my-account/MyAccount'
import {ITab, KTTab} from 'helpers/ui-components/KTTab'
import GeographyMapping from './manage-user/GeographyMapping'
import NetworkMapping from './manage-user/NetworkMapping'
import HierarchyMapping from './manage-user/HierarchyMapping'
import BusinessVertical from './manage-user/BusinessVertical'
import {Button} from 'helpers'
import {DefaultApiResponse} from 'models/ApiResponse'
import {toast} from 'react-toastify'
import {KTRejectionPopup} from 'helpers/ui-components/KTRejectionPopup'
import {KTConfirmPopup} from 'helpers/ui-components/KTConfirmPopup'

type IProps = {
 actionDetails?: IUserAction | null
 tabList?: ITab[]
 setActionDetails: (newState: IUserAction | null) => void
 onReturnToUserManagement?: () => void
 onReturnToTab?: (tabId: string) => void
}

const actionTypeToTabId = (actionType: string) =>
 actionType === 'activate_user' ? 'activate' : actionType

const UserAction = (props: IProps) => {
 const navigate = useNavigate()
 const {t} = useTranslation()
 const {userData} = useAuth()
 const accessDetails =
  userData?.userSubModule?.userManagement
 const [loader, setLoader] = useState(false)
 const [tabList, setTabList] = useState<ITab[]>([])
 const [rejectionModel, setRejectionModel] = useState(false)
 const [confirmModel, setConfirmModel] = useState(false)
 const [userDetails, setUserDetails] =
  useState<IFormField | null>()
 const [rejectionData, setRejectionData] =
  useState<IFormField | null>()
 const [activeTab, setActiveTab] = useState('')
 const userId = props.actionDetails?.userId ?? ''
 const actionType = props.actionDetails?.actionType ?? ''
 const [breadcrumbs, setBreadcrumbs] = useState<PageLink[]>(
  [
   {
    title: t('breadCrumbs.userManagement'),
    path: '',
    isActive: false,
    className: 'text-[#4E83E4]',
    onClick: () => {
     props.setActionDetails(null)
     props.onReturnToUserManagement?.()
     navigate('/user-management')
    },
   },
  ]
 )

 const getUserDetails = async () => {
  setLoader(true)
  const userRes: IUserDetails | null =
   await fetchUserDetails(userId)
  if (userRes) {
   setUserDetails(userRes)
   setBreadcrumbs((prevState) => [
    ...prevState,
    {
     title: userRes.full_name,
     path: '',
     isActive: true,
    },
   ])
  }
  setLoader(false)
 }

 const getUserActivationConfig = async () => {
  setLoader(true)
  const userRes: IActivationConfig[] | null =
   await userActivationConfig(userId)
  if (userRes && userRes?.length > 0) {
   const tabs: ITab[] = []
   userRes.map(async (val: IActivationConfig) => {
    tabs.push({
     title: val.name,
     id: val.key,
    })
   })
   setTabList(tabs)
  }
  setLoader(false)
 }

 const handleTabClick = async (index: string) => {
  setActiveTab(index)
 }

 useEffect(() => {
  if (actionType) {
   const breadcrumb = props.tabList?.find(
    (item) => item.id === actionType
   )
   if (breadcrumb) {
    setBreadcrumbs((prevState) => [
     ...prevState,
     {
      title: breadcrumb.title,
      path: '',
      isActive: false,
      className: 'text-[#4E83E4]',
      onClick: () => {
       props.setActionDetails(null)
       props.onReturnToTab?.(actionTypeToTabId(actionType))
      },
     },
    ])
   }
   if (actionType === 'manage_user') {
    void getUserActivationConfig()
   }
  }
 }, [actionType])

 useEffect(() => {
  if (userId) {
   void getUserDetails()
  }
 }, [userId])

 const handleConfirmUserBtnClick = async (
  isConfirm: boolean
 ) => {
  if (isConfirm) {
   if (userDetails) {
    let res: DefaultApiResponse | null = null
    setLoader(true)
    if (userDetails.is_active) {
     res = await deActivateUser(userDetails.id)
    } else {
     res = await activateUser(userDetails.id)
    }

    setLoader(false)
    if (res) {
     toast.success(res.message)
     setConfirmModel(false)
     props.setActionDetails(null)
    }
   }
  } else {
   props.setActionDetails(null)
   setConfirmModel(false)
  }
 }

 const handleActionButtonClick = async (action: string) => {
  if (!userId) return null

  switch (actionType) {
   case 'pending_user_action': {
    const res: DefaultApiResponse | null =
     action === 'reject'
      ? await bulkApproveRejectUsers({
         user_ids: [Number(userId)],
         status: 'rejected',
        })
      : await sendVerificationLink({
         user_data: [
          {
           full_name: userDetails?.full_name,
           organisation: userDetails?.organisation,
           user_category: userDetails?.user_category,
           phone_number: userDetails?.phone_number,
          },
         ],
        })
    setLoader(false)
    if (res) {
     toast.success(res.message)
     props.setActionDetails(null)
    }
    break
   }
   case 'approvals': {
    if (action === 'rejected') {
     setRejectionData({
      reason: 'user_registration',
      status: action,
     })
     setRejectionModel(true)
    } else {
     const res: DefaultApiResponse | null =
      await bulkApproveRejectUsers({
       user_ids: [Number(userId)],
       status: 'approved',
      })
     setLoader(false)
     if (res) {
      toast.success(res.message)
      props.setActionDetails(null)
     }
    }

    break
   }

   default:
    return null
  }
 }

 async function submitRejectionForm(formData: IFormData) {
  if (rejectionData) {
   setLoader(true)
   const payload: IApproveReject = {
    user_ids: [Number(userId)],
    status: rejectionData.status,
    rejection_reason_id: Number(formData.rejectionIds),
   }
   const res: DefaultApiResponse | null =
    await bulkApproveRejectUsers(payload)
   setLoader(false)
   if (res) {
    toast.success(res.message)
    setRejectionModel(false)
    setRejectionData(null)
    props.setActionDetails(null)
   }
  }
 }

 const renderActionButtons = () => {
  const userId = props.actionDetails?.userId
  if (!userId) return null

  switch (actionType) {
   case 'pending_user_action':
    return (
     <>
      <Button
       type='button'
       disabled={
        !accessDetails?.pendingUserAction?.section?.reject
         ?.canEdit
       }
       onClick={() => {
        if (
         accessDetails?.pendingUserAction?.section?.reject
          ?.canEdit
        ) {
         void handleActionButtonClick('reject')
        }
       }}
       color='blue'
       className='text-center py-[9px] px-6 bg-[#FFEBED] 
                           !rounded-lg text-base text-[#CC293F] font-semibold border-[#CC293F] hover:bg-[#CC293F] hover:text-white mr-4 w-[167px]'
      >
       {t('userManagement.pendingUserAction.reject')}
      </Button>
      <Button
       type='button'
       disabled={
        !accessDetails?.pendingUserAction?.section
         ?.sendReminder?.canEdit
       }
       onClick={() => {
        if (
         accessDetails?.pendingUserAction?.section
          ?.sendReminder?.canEdit
        ) {
         void handleActionButtonClick('send_reminder')
        }
       }}
       color='blue'
       className='text-center py-[9px] px-6 bg-[#4E83E4] hover:bg-white hover:text-[#4E83E4]
                            !rounded-lg text-base text-white font-semibold border-[#4E83E4]'
      >
       {t('userManagement.pendingUserAction.sendReminder')}
      </Button>
     </>
    )

   case 'approvals':
    return (
     <>
      <Button
       type='button'
       disabled={
        !accessDetails?.approvals?.section?.reject?.canEdit
       }
       onClick={() => {
        if (
         accessDetails?.approvals?.section?.reject?.canEdit
        ) {
         void handleActionButtonClick('rejected')
        }
       }}
       color='blue'
       className='text-center py-[9px] px-6 bg-[#FFEBED] 
                           !rounded-lg text-base text-[#CC293F] font-semibold border-[#CC293F] hover:bg-[#CC293F] hover:text-white mr-4 w-[167px]'
      >
       {t('userManagement.approvals.reject')}
      </Button>
      <Button
       type='button'
       disabled={
        !accessDetails?.approvals?.section?.approve?.canEdit
       }
       onClick={() => {
        if (
         accessDetails?.approvals?.section?.approve?.canEdit
        ) {
         void handleActionButtonClick('approve')
        }
       }}
       color='blue'
       className='text-center py-[9px] px-6 bg-[#DAF5E6] text-[#0E7A41] 
                     !rounded-lg text-base font-semibold border-[#0E7A41] hover:bg-[#0E7A41] hover:text-white'
      >
       {t('userManagement.approvals.approve')}
      </Button>
     </>
    )

   case 'manage_user':
    return (
     <>
      {userDetails?.is_active ? (
       <Button
        type='button'
        disabled={
         !accessDetails?.manageUser?.section?.activate
          ?.canEdit
        }
        onClick={() => {
         if (
          accessDetails?.manageUser?.section?.activate
           ?.canEdit
         ) {
          void setConfirmModel(true)
         }
        }}
        color='blue'
        className='text-center py-[9px] px-6 bg-[#FFEBED] 
                           !rounded-lg text-base text-[#CC293F] font-semibold border-[#CC293F] hover:bg-[#CC293F] hover:text-white mr-4 w-[167px]'
       >
        {t('userManagement.manageUser.deActivate')}
       </Button>
      ) : (
       <Button
        type='button'
        disabled={
         !accessDetails?.manageUser?.section?.activate
          ?.canEdit
        }
        onClick={() => {
         if (
          accessDetails?.manageUser?.section?.activate
           ?.canEdit
         ) {
          void setConfirmModel(true)
         }
        }}
        color='blue'
        className='text-center py-[9px] px-6 bg-[#DAF5E6] text-[#0E7A41] 
                     !rounded-lg text-base font-semibold border-[#0E7A41] hover:bg-[#0E7A41] hover:text-white'
       >
        {t('userManagement.manageUser.activate')}
       </Button>
      )}
     </>
    )

   default:
    return null
  }
 }

 return (
  <>
   {loader && <Spinner />}
   {confirmModel && userDetails && (
    <KTConfirmPopup
     showConfirmModel={confirmModel}
     handleConfirmBtnClick={handleConfirmUserBtnClick}
     yesBtnText={t('common.yes')}
     noBtnText={t('common.no')}
     title={t('common.confirmModalTitle')}
     subTitle={`${t('common.confirmModalSubTitle')} ${
      userDetails?.is_active ? 'Inactive' : 'Active'
     } this ${userDetails.full_name} ${
      userDetails.category
       ? `(${userDetails.category})`
       : ''
     }?`}
    />
   )}
   {rejectionModel && rejectionData && (
    <KTRejectionPopup
     title={t('userManagement.approvals.reasonTitle')}
     btnText={t('userManagement.approvals.confirm')}
     submitRejectionForm={submitRejectionForm}
     showRejectionModal={rejectionModel}
     reason={rejectionData.reason}
     setShowRejectionModal={setRejectionModel}
     setLoader={setLoader}
    />
   )}
   <div className='w-full'>
    <PageTitle
     breadcrumbContainerClass={
      'flex text-[#5A6066] text-sm font-normal items-center pb-6 border-[#E6EBF0] border-b'
     }
     breadcrumbs={breadcrumbs}
     description='Welcome'
    >
     Manage User
    </PageTitle>
    <div className='w-full min-h-full'>
     <div className='mb-8 mt-4'>
      <MyAccountPage
       userId={userId}
       userCategoryKey={userDetails?.user_category_key}
      />
     </div>
     {userDetails &&
      actionType === 'manage_user' &&
      accessDetails?.manageUser?.section?.activationFlow
       ?.canView && (
       <KTTab
        activeTabId={activeTab}
        containerClass='my-6'
        tabHeaderContainerClass='mb-6 !justify-center'
        tabHeaderClass='px-[20px]'
        activeClass='text-[#4E83E4] font-semibold border-b-[3px] border-[#4E83E4] '
        onClick={handleTabClick}
        tabs={tabList}
        disableHash={!!userId}
        tabContent={
         <div>
          {activeTab === 'geography_mapping' ? (
           <GeographyMapping
            accessDetails={
             accessDetails?.manageUser?.section
            }
            userDetails={userDetails}
            setLoader={setLoader}
            loggedInUserId={userData?.userId}
            userRole={userDetails?.user_category_key}
           />
          ) : activeTab === 'network_mapping' ? (
           <NetworkMapping
            accessDetails={
             accessDetails?.manageUser?.section
            }
            userDetails={userDetails}
            setLoader={setLoader}
            loggedInUserId={userData?.userId}
            userRole={userDetails?.user_category_id}
           />
          ) : activeTab === 'hierarchy_mapping' ? (
           <HierarchyMapping
            accessDetails={
             accessDetails?.manageUser?.section
            }
            userDetails={userDetails}
            setLoader={setLoader}
            loggedInUserId={userData?.userId}
            userRole={userDetails?.user_category_id}
           />
          ) : activeTab === 'line_of_business' ? (
           <BusinessVertical
            accessDetails={
             accessDetails?.manageUser?.section
            }
            userDetails={userDetails}
            setLoader={setLoader}
            loggedInUserId={userData?.userId}
            userRole={userDetails?.user_category_id}
           />
          ) : (
           <></>
          )}
         </div>
        }
       />
      )}
    </div>
    <div
     className='fixed bottom-0 left-0 bg-white w-full '
     style={{
      boxShadow: '0px -2px 6px 0px rgba(0, 0, 0, 0.16)',
     }}
    >
     <div
      className='fixed bottom-0 left-0 bg-white w-full '
      style={{
       boxShadow: '0px -2px 6px 0px rgba(0, 0, 0, 0.16)',
      }}
     >
      <div className='container flex items-center justify-end py-6 px-[76px]'>
       {renderActionButtons()}
      </div>
     </div>
    </div>
   </div>
  </>
 )
}

export {UserAction}
